Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Footnote2371257",
  {"root":"Footnote2371257--root","innerContent":"Footnote2371257--innerContent"},
  ".Footnote2371257--root{width:100%}.Footnote2371257--innerContent{padding:12px 30px;display:flex;justify-content:center}",
  3,
  "Footnote2371257"
);
__webpack_require__.stylable.$.register(exports.default)
